(() => {
  const run = () => {
    const m = document.getElementById('ATS-NewsletterPopup');
    if (!m) return;

    const ls = localStorage,
      DIS = 'ats_nl_dismissed_at',
      SUB = 'ats_nl_subscribed',
      CAP = 7;

    if (ls.getItem(SUB) === '1') return;

    const d = ls.getItem(DIS);
    if (d && (Date.now() - +d) / 864e5 < CAP) return;

    const emailInput = m.querySelector('input[name="contact[email]"]');
    const dobInput   = m.querySelector('#ATS-nl-dob');
    const tagsInput  = m.querySelector('#ATS-nl-tags');

    const syncTags = () => {
      if (!tagsInput) return;
      const dob = dobInput?.value || '';

      const tags = [];

      // If you still want a generic tag, uncomment:
      // tags.push('newsletter');

      if (dob) {
        // Store DOB as a single structured tag
        tags.push(`${dob}`); // e.g. dob:2000-05-01
      }

      tagsInput.value = tags.join(', ');
    };

    const show = () => {
      m.classList.remove('ats-nl-hidden');
      document.documentElement.style.overflow = 'hidden';
      emailInput?.focus({ preventScroll: true });
    };

    const hide = () => {
      m.classList.add('ats-nl-hidden');
      document.documentElement.style.overflow = '';
    };

    setTimeout(show, (+m.dataset.delay || 12) * 1000);

    m.querySelectorAll('[data-nl-close]').forEach((b) =>
      b.addEventListener('click', () => {
        ls.setItem(DIS, Date.now());
        hide();
      })
    );

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !m.classList.contains('ats-nl-hidden')) {
        ls.setItem(DIS, Date.now());
        hide();
      }
    });

    dobInput?.addEventListener('change', syncTags);

    m.querySelector('[data-nl-form]')?.addEventListener('submit', () => {
      syncTags();            // ensure latest DOB in tags
      ls.setItem(SUB, '1');
      setTimeout(hide, 400);
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', run)
    : run();
})();
